export const getNumericalValue = (value, round=2) => {
  if (value === '0.0 %') {
    return '0 %'
  }
  if (typeof (value) === typeof (1)) {
    if (value === 0) {
      return '-';
    }
    value = value.toFixed(round).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
  }
  if (value === '0') {
    return '-'
  }
  return value;
};

let debounceTimer;
export const debounce = (cb, duration) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(cb, duration);
}
